<section id="privacidad" class="scroll-animations skills">
    <div class="container">
  
        <div class="row">
            <div class="col-sm-12 mt-5">
                <h2>Política de privacidad</h2>
                <p class="header_subtitle animated">Aspectos generales</p>
  
  
  
                <p>
                  En cumplimiento de lo dispuesto en la Ley Orgánica 15/1999, de 13 de Diciembre, de Protección de Datos de Carácter Personal (LOPD) se informa al usuario que todos los datos que nos proporcione serán incorporados a un fichero, creado y mantenido bajo la responsabilidad de Zeeker Solutions S.L.
                </p>
                <p>
                  Siempre se va a respetar la confidencialidad de sus datos personales que sólo serán utilizados con la finalidad de gestionar los servicios ofrecidos, atender a las solicitudes que nos plantee, realizar tareas administrativas, así como remitir información técnica, comercial o publicitaria por vía ordinaria o electrónica.
                </p>
                <p>
                  Para ejercer sus derechos de oposición, rectificación o cancelación deberá dirigirse a la sede de la empresa c/Henry Dunant 15-17, escribirnos al siguiente correo admin&#64;zeeker.es o llámanos al 649586937.
                </p>
            </div>
        </div>
      
        <div class="row">
            <div class="col-sm-12 mt-5">
  
                <p class="header_subtitle animated">Responsabilidades</p>
  
  
  
                <p>
                    Zeeker Solutions S.L no se hace responsable de la información y contenidos almacenados en foros, redes sociales o cualesquier otro medio que permita a terceros publicar contenidos de forma independiente en la página web del prestador.
                </p>
                <p>
                    Sin embargo, teniendo en cuenta los art. 11 y 16 de la LSSI-CE, Zeeker Solutions S.L se compromete a la retirada o en su caso bloqueo de aquellos contenidos que pudieran afectar o contravenir la legislación nacional o internacional, derechos de terceros o la moral y el orden público.
  
  
                </p>
                <p>
                    Tampoco la empresa se responsabilizará de los daños y perjuicios que se produzcan por fallos o malas configuraciones del software instalado en el ordenador del internauta. Se excluye toda responsabilidad por alguna incidencia técnica o fallo que se produzca cuando el usuario se conecte a internet. Igualmente, no se garantiza la inexistencia de interrupciones o errores en el acceso al sitio web.
                </p>
  
                <p>
                    Así mismo, Zeeker Solutions S.L se reserva el derecho a actualizar, modificar o eliminar la información contenida en su página web, así como la configuración o presentación del mismo, en cualquier momento sin asumir alguna responsabilidad por ello.
  
  
                </p>
                <p>
                    Le comunicamos que cualquier precio que pueda ver en nuestra web será solamente orientativo. Si el usuario desea saber con exactitud el precio o si el producto en el momento actual cuenta con alguna oferta de la cual se puede beneficiar ha de acudir a alguna de las tiendas físicas con las que cuenta Zeeker Solutions S.L.
                </p>
            </div>
        </div>
  
    </div>
  </section>